import { format } from "date-fns";
import { useMemo, useState } from "react";

import { STRINGS } from "../utils/strings";

export function useActionItemRow({ actionItem, onEdit, onDelete, onView, onNavigateToClient }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const { onCase, actingUser, assignedRole, actionDetail, formUrl, actionTypeLabel, status } =
    actionItem || {};
  const name = actingUser?.name || assignedRole?.name || STRINGS.DEFAULT_VALUE;

  const actionText = useMemo(() => {
    const normalizedActionDetail =
      typeof actionDetail === "string" && actionDetail.trim().length > 0
        ? actionDetail.trim()
        : null;
    const hasFormUrl = typeof formUrl === "string" && formUrl.trim().length > 0;

    if (hasFormUrl) {
      return STRINGS.SEE_FORM;
    }

    if (normalizedActionDetail) {
      return normalizedActionDetail;
    }

    return STRINGS.NA;
  }, [actionDetail, formUrl]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit(actionItem);
    handleMenuClose();
  };

  const handleDelete = () => {
    onDelete(actionItem);
    handleMenuClose();
  };

  const handleView = () => {
    onView(actionItem);
    handleMenuClose();
  };

  const handleNavigateClick = () => {
    onNavigateToClient(onCase);
  };

  const formatDueDate = (date) => {
    if (!date) {
      return STRINGS.DEFAULT_VALUE;
    }
    try {
      return format(new Date(date), "MM/dd/yyyy");
    } catch (err) {
      return STRINGS.DEFAULT_VALUE;
    }
  };

  const truncate = (str, maxLength = 50) => {
    if (!str) {
      return "";
    }
    return str.length > maxLength ? str.substring(0, maxLength) + "..." : str;
  };

  const getClientName = () => {
    return (
      actionItem.onCase?.client?.name || actionItem.on_case?.client?.name || STRINGS.DEFAULT_VALUE
    );
  };

  const getCreatedByName = () => {
    return actionItem.createdBy?.name || actionItem.created_by?.name || STRINGS.DEFAULT_VALUE;
  };

  const getDueDate = () => {
    return formatDueDate(actionItem.dueDate || actionItem.due_date);
  };

  return {
    anchorEl,
    menuOpen,
    name,
    actionTypeLabel,
    actionText,
    onCase,
    status,
    handleMenuOpen,
    handleMenuClose,
    handleEdit,
    handleDelete,
    handleView,
    handleNavigateClick,
    truncate,
    getClientName,
    getCreatedByName,
    getDueDate,
  };
}
